import React from 'react';
import SEO from '../common/SEO';
import SafeIcon from '../common/SafeIcon';

const ContactPage = () => {
  return (
    <>
      <SEO 
        title="Kontakt – LightWell | Poptávka a konzultace LED projektů"
        description="Kontaktujte nás pro výpočet osvětlení nebo technickou konzultaci k LEDBAR systémům. Sídlíme v ČR a dodáváme kompletní LED řešení pro reklamu."
        path="/kontakt"
      />
      <div className="pt-20">
        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4">
            <div className="text-center mb-16">
              <h1 className="text-5xl md:text-7xl font-bold italic tracking-tighter uppercase mb-6 text-gray-900">Kontaktujte nás</h1>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto">Máte projekt, který potřebuje kvalitní osvětlení? Jsme tu pro vás.</p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 bg-gray-900 rounded-[3rem] p-8 md:p-16 text-white overflow-hidden relative">
              <div className="absolute top-0 right-0 w-96 h-96 bg-blue-600/20 blur-[100px] rounded-full"></div>
              
              <div className="relative z-10">
                <h2 className="text-3xl font-bold mb-10 italic uppercase tracking-tighter">Spojte se s námi</h2>
                <div className="space-y-8">
                  <div className="flex items-center gap-6">
                    <div className="w-14 h-14 bg-blue-600 rounded-2xl flex items-center justify-center shrink-0 shadow-lg shadow-blue-600/30">
                      <SafeIcon name="Phone" className="w-6 h-6" />
                    </div>
                    <div>
                      <div className="text-xs font-bold text-blue-400 uppercase tracking-widest mb-1">Telefon</div>
                      <a href="tel:+420777016374" className="text-2xl font-bold hover:text-blue-400 transition-colors">+420 777 016 374</a>
                    </div>
                  </div>
                  <div className="flex items-center gap-6">
                    <div className="w-14 h-14 bg-blue-600 rounded-2xl flex items-center justify-center shrink-0 shadow-lg shadow-blue-600/30">
                      <SafeIcon name="Mail" className="w-6 h-6" />
                    </div>
                    <div>
                      <div className="text-xs font-bold text-blue-400 uppercase tracking-widest mb-1">E-mail</div>
                      <a href="mailto:info@lightwell.cz" className="text-2xl font-bold hover:text-blue-400 transition-colors">info@lightwell.cz</a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-[2.5rem] p-8 md:p-10 relative z-10 text-gray-900">
                <h3 className="text-2xl font-bold mb-8 italic uppercase tracking-tighter">Poptávkový formulář</h3>
                <form name="kontakt" method="POST" data-netlify="true" data-netlify-honeypot="bot-field" action="/dekujeme" className="space-y-4">
                  <input type="hidden" name="form-name" value="kontakt" />
                  <input type="hidden" name="bot-field" />
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <input type="text" name="jmeno" placeholder="Vaše jméno" required className="w-full px-5 py-4 bg-gray-50 border border-gray-100 rounded-2xl focus:ring-2 focus:ring-blue-600 outline-none transition-all text-sm" />
                    <input type="text" name="firma" placeholder="Firma" className="w-full px-5 py-4 bg-gray-50 border border-gray-100 rounded-2xl focus:ring-2 focus:ring-blue-600 outline-none transition-all text-sm" />
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <input type="email" name="email" placeholder="E-mail" required className="w-full px-5 py-4 bg-gray-50 border border-gray-100 rounded-2xl focus:ring-2 focus:ring-blue-600 outline-none transition-all text-sm" />
                    <input type="tel" name="telefon" placeholder="Telefon" className="w-full px-5 py-4 bg-gray-50 border border-gray-100 rounded-2xl focus:ring-2 focus:ring-blue-600 outline-none transition-all text-sm" />
                  </div>
                  <textarea name="zprava" placeholder="Váš dotaz..." rows="4" required className="w-full px-5 py-4 bg-gray-50 border border-gray-100 rounded-2xl focus:ring-2 focus:ring-blue-600 outline-none transition-all text-sm resize-none"></textarea>
                  <button type="submit" className="w-full py-5 bg-blue-600 text-white rounded-2xl font-bold uppercase tracking-widest hover:bg-blue-700 transition-all shadow-xl shadow-blue-600/20">
                    Odeslat poptávku
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ContactPage;